<app-header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="offers-header country-poll-header">
  <div class="country-poll-header-inner">
    <h1 class="offers-header-title">{{getString('countryPollHeadline')}}</h1>
    <p>{{getString('countryPollIntro')}}</p>
  </div>
</div>

<div class="page-content country-poll-page">
  <div class="poll-grid">
    <div class="poll-card vote-card">
      <h2>{{getString('countryPollChooseCountry')}}</h2>
      <p class="muted">{{getString('countryPollVoteHelp')}}</p>

      <div class="search-box">
        <input type="text"
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChanged()"
          [placeholder]="getString('countryPollSearchPlaceholder')"
          [disabled]="countriesLoading || countries.length === 0">
      </div>

      <div *ngIf="countriesLoading" class="state-box">
        <app-spinner></app-spinner>
      </div>

      <div *ngIf="countriesError && !countriesLoading" class="state-box error-text">{{countriesError}}</div>

      <div *ngIf="!countriesLoading && !countriesError" class="country-list">
        <button type="button"
          class="country-row"
          *ngFor="let country of filteredCountries; trackBy: trackByCountryCode"
          [class.selected]="selectedCountry && selectedCountry.code === country.code"
          (click)="selectCountry(country)">
          <img alt="" class="round-flag" [src]="getFlagUrl(country)">
          <span>{{getCountryName(country)}}</span>
        </button>
      </div>

      <div *ngIf="!countriesLoading && !countriesError && filteredCountries.length === 0" class="state-box">
        {{getString('countryPollNoMatchingCountry')}}
      </div>

      <div class="selected-vote" *ngIf="selectedCountry">
        <div class="selected-country">
          <img alt="" class="round-flag large" [src]="getFlagUrl(selectedCountry)">
          <div>
            <div class="selected-label">{{getString('countryPollSelectedCountry')}}</div>
            <div class="selected-name">{{getCountryName(selectedCountry)}}</div>
          </div>
        </div>
        <button type="button" class="blue-button vote-button" (click)="vote()" [disabled]="voteLoading">
          {{voteLoading ? getString('countryPollVoting') : getString('countryPollVote')}}
        </button>
      </div>

      <div *ngIf="successMessage" class="success-box">{{successMessage}}</div>
      <div *ngIf="voteError" class="error-text vote-error">{{voteError}}</div>
    </div>

    <div class="poll-card results-card">
      <h2>{{getString('countryPollCurrentTop5')}}</h2>
      <p class="muted">{{getString('countryPollTop5Help')}}</p>

      <div *ngIf="resultsLoading" class="state-box">
        <app-spinner></app-spinner>
      </div>

      <div *ngIf="resultsError && !resultsLoading" class="state-box error-text">{{resultsError}}</div>

      <div *ngIf="!resultsLoading && !resultsError && topCountries.length === 0" class="state-box">
        {{getString('countryPollNoVotesYet')}}
      </div>

      <div *ngIf="!resultsLoading && !resultsError && topCountries.length > 0" class="results-list">
        <div class="result-row" *ngFor="let country of topCountries; let i = index; trackBy: trackByCountryCode">
          <div class="result-header">
            <div class="result-country">
              <span class="rank">{{i + 1}}</span>
              <img alt="" class="round-flag" [src]="getFlagUrl(country)">
              <span>{{getCountryName(country)}}</span>
            </div>
            <span class="vote-count">{{getVoteCountText(country)}}</span>
          </div>
          <div class="bar-track">
            <div class="bar-fill" [style.width.%]="getVotePercent(country)"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-home-footer></app-home-footer>
